import React from "react";
import PolicyPage from "./PolicyPage";

const sections = [
  {
    title: "Information forming the product record",
    paragraphs: ["The item name, photographs, intended use, listed material, dimensions, colour, selectable variant, care direction and safety note should be read together. The variant shown in the basket is the one attached to the order; customers should check it before Pay Now."],
  },
  {
    title: "Colour and surface variation",
    paragraphs: ["Screen calibration and lighting can shift perceived colour. Glazed ceramic, plated or silver-toned jewellery, printed paper, cotton yarn, velvet and naturally textured materials can show modest surface or shade variation between units. Variation is normal only while the item remains consistent with its essential description and selected colour family."],
  },
  {
    title: "Dimensions and fit",
    paragraphs: ["Listed measurements are approximate and use the unit shown on the product page. Apparel and bags should be checked against the stated garment or item dimensions rather than an assumed sizing system. A print dimension covers the supplied artwork and does not add a frame. Small handmade or soft-goods variation must not materially change function or fit."],
  },
  {
    title: "Material-specific expectations",
    items: [
      "Paper and board may show fibre and cut variation but should arrive dry, legible and usable.",
      "Ceramic glaze can vary slightly in pooling and sheen; a sharp chip, structural crack or unstable handle is not normal variation.",
      "Textile pile, weave and stitching can differ subtly; an open seam or missing component is a fault, not texture.",
      "Body-care colour, scent intensity or viscosity can vary between batches within the stated formula; leakage, contamination or an inconsistent physical label should be reported.",
      "Metal finishes develop wear according to contact and care, but the supplied material and form must match the listing.",
    ],
  },
  {
    title: "Before use and reporting a mismatch",
    paragraphs: ["Read the physical label and inspect the received product before use, especially cosmetics, children's goods, ceramic drinkware and items containing small parts. A material, size, colour or specification that is materially different from the order should be photographed with its label and reported under Returns, Refunds & Exchanges."],
    links: [["Returns, Refunds & Exchanges", "/returns"]],
  },
];

export default function ProductInformation() {
  return <PolicyPage title="Product Descriptions, Colour & Material Variation" intro="How to read item pages and distinguish expected material character from a product mismatch." sections={sections} related={[["Product Safety & Care", "/product-safety"], ["Sale & Clearance", "/sale-clearance"]]} />;
}
